import { gql } from '@apollo/client';

const DATA_WAREHOUSE_EXPORTS = gql`
    query DataWarehouseExports($options: DW_OptionsInput) {
        dataWarehouseExports(options: $options) {
        totalCount
        edges {      
            node {
            id
            exportTypeId
            s3Key
            format
            status
            rowCount
            fileSizeHuman
            metadata
            startedAt
            completedAt
            createdAt
            updatedAt
            }
        }
        options {
            page
            limit
            orderBy
            orderDir
            formats
            exportTypes
            statuses
        }
        pagination
    }
}
`;

/*
input DW_OptionsInput {
    formats: (
        json,
        csv
    )[]
    exportTypes: (
        BAYER_MANAGER_EMAIL,
        BAYER_USER_ACTIVITY,
        COURSES,
        CURRICULA,
        DAILY_BIW_ACTIVITY_REPORT,
        ENROLLMENTS,
        LEARNING_OBJECTS,
        MASTER_CONTENT,
        TOYOTA_USER_ACTIVITY,
        TRANSLATIONS,
        USER_ACTIVITY
    )[]
    statuses: (
        COMPLETED,
        ERROR,
        IN_PROGRESS,
        PENDING
    )[]
    page: Int
    limit: Int
    orderBy: (createdAt)
    orderDir: (
        asc,
        desc
    )

}
*/

export default DATA_WAREHOUSE_EXPORTS;
